import type { EditorView } from 'prosemirror-view';

// Duplicate of TEXTFIELD_ID from @atlassian/dynamic-cards-search-page
const COMPANY_HUB_SEARCH_TEXTFIELD_ID = 'ch-search-text-query-input';

export const handleCompanyHubSearchInput = (
	_view: EditorView,
	event: KeyboardEvent | InputEvent,
) => {
	/**
	 * We have to use the event.target to indentify that we are dealing with the Company Hub search extension
	 * instead of the current editor selection because
	 *   1. We can’t guarantee the selection won’t change while we are in the extension
	 *   2. Often times the selection is not the extension despite currently interacting with the extension
	 *
	 * As a result, we have to rely on the event.target to identify if the current event is meant for the
	 * Company Hub search extension.
	 */
	return (
		event.target instanceof HTMLInputElement &&
		(event.target as HTMLElement).id === COMPANY_HUB_SEARCH_TEXTFIELD_ID
	);
};

/**
 * When interacting with input elements inside an extension's body, the events
 * bubble up to the editor and get handled by it.
 *
 * This almost always gets in the way of being able to actually interact with said input in the extension, i.e.
 * typing inside a text field (in an extension body) will print the text in the editor
 * content area instead.
 *
 * These event handlers are to prevent the editor view from trying to handle these events,
 * for the Company Hub search extension in particular.
 */
export const eventHandlersForCompanyHubSearchExtension = {
	keydown: handleCompanyHubSearchInput,
	keyup: handleCompanyHubSearchInput,
	keypress: handleCompanyHubSearchInput,
	beforeinput: handleCompanyHubSearchInput,
};
